import React, { Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import { QuotationSettings } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DropdownList } from "react-widgets";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: QuotationSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: QuotationSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<QuotationSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderQuotationExpiry = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Proposal Expiry<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-6">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: "Proposal Expiry is required",
                  validate: {
                    numberOnly: (value) =>
                      new RegExp("\\d+").test(value) || "Invalid value",
                    min: (value) =>
                      Number(value) >= 0 || "Value shoud be positive",
                  },
                }}
                name="expiry.value"
                defaultValue={props.data?.expiry?.value}
                render={({ onChange, value, name }) => (
                  <input
                    type="number"
                    min={0}
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Proposal Expiry"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="expiry.value"
                  />
                )}
              />
              <ErrorMessage>{errors.expiry?.value?.message}</ErrorMessage>
            </div>
          </div>
          <div className="col-6">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="expiry.unit"
                defaultValue={props.data?.expiry?.unit || "Hours"}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    data={[
                      {
                        label: "Minutes",
                        value: "Minutes",
                      },
                      {
                        label: "Hours",
                        value: "Hours",
                      },
                      {
                        label: "Days",
                        value: "Days",
                      },
                    ]}
                    id="expiry.unit"
                    placeholder="Unit"
                    name={name}
                    defaultValue={"Hours"}
                    value={value}
                    onChange={(val) => onChange(val.value)}
                    textField="label"
                    valueField="value"
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCustomerEmailMandatory = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="isCustomerEmailMandatoryForQuotation"
            defaultValue={props.data?.isCustomerEmailMandatoryForQuotation}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>
                  Is Customer Email Mandatory For Proposal Creation?
                </label>
              </Fragment>
            )}
          />
          <ErrorMessage>
            {errors.isCustomerEmailMandatoryForQuotation?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Proposal Settings</h4>
        <div className="row gutter-10">
          {renderQuotationExpiry()}
          {renderCustomerEmailMandatory()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
